import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RptloanpopupComponent } from "../../shared/popup/rptloanpopup/rptloanpopup.component";

@Component({
  selector: 'app-popupheader',
  templateUrl: './popupheader.component.html',
  styleUrls: ['./popupheader.component.css']
})
export class PopupheaderComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<RptloanpopupComponent>) { }

  ngOnInit() {
  }

  onClick(): void {
    this.dialogRef.close();
     }

}
